function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var s = 4;
var e = /*#__PURE__*/function () {
  function e(_e) {
    _classCallCheck(this, e);
    this.expr = _e, this.index = 0;
  }
  _createClass(e, [{
    key: "char",
    get: function get() {
      return this.expr.charAt(this.index);
    }
  }, {
    key: "code",
    get: function get() {
      return this.expr.charCodeAt(this.index);
    }
  }, {
    key: "throwError",
    value: function throwError(_e5) {
      var t = new Error(_e5 + " at character " + this.index);
      throw t.index = this.index, t.description = _e5, t;
    }
  }, {
    key: "runHook",
    value: function runHook(t, r) {
      if (e.hooks[t]) {
        var _i = {
          context: this,
          node: r
        };
        return e.hooks.run(t, _i), _i.node;
      }
      return r;
    }
  }, {
    key: "searchHook",
    value: function searchHook(t) {
      if (e.hooks[t]) {
        var _r = {
          context: this
        };
        return e.hooks[t].find(function (e) {
          return e.call(_r.context, _r), _r.node;
        }), _r.node;
      }
    }
  }, {
    key: "gobbleSpaces",
    value: function gobbleSpaces() {
      var t = this.code;
      for (; t === e.SPACE_CODE || t === e.TAB_CODE || t === e.LF_CODE || t === e.CR_CODE;) t = this.expr.charCodeAt(++this.index);
      this.runHook("gobble-spaces");
    }
  }, {
    key: "parse",
    value: function parse() {
      this.runHook("before-all");
      var t = this.gobbleExpressions(),
        r = 1 === t.length ? t[0] : {
          type: e.COMPOUND,
          body: t
        };
      return this.runHook("after-all", r);
    }
  }, {
    key: "gobbleExpressions",
    value: function gobbleExpressions(t) {
      var r,
        i,
        s = [];
      for (; this.index < this.expr.length;) if (r = this.code, r === e.SEMCOL_CODE || r === e.COMMA_CODE) this.index++;else if (i = this.gobbleExpression()) s.push(i);else if (this.index < this.expr.length) {
        if (r === t) break;
        this.throwError('Unexpected "' + this["char"] + '"');
      }
      return s;
    }
  }, {
    key: "gobbleExpression",
    value: function gobbleExpression() {
      var _e6 = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
      return this.gobbleSpaces(), this.runHook("after-expression", _e6);
    }
  }, {
    key: "gobbleBinaryOp",
    value: function gobbleBinaryOp() {
      this.gobbleSpaces();
      var t = this.expr.substr(this.index, e.max_binop_len),
        r = t.length;
      for (; r > 0;) {
        if (e.binary_ops.hasOwnProperty(t) && (!e.isIdentifierStart(this.code) || this.index + t.length < this.expr.length && !e.isIdentifierPart(this.expr.charCodeAt(this.index + t.length)))) return this.index += r, t;
        t = t.substr(0, --r);
      }
      return !1;
    }
  }, {
    key: "gobbleBinaryExpression",
    value: function gobbleBinaryExpression() {
      var t, r, i, s, n, o, h, a, l;
      if (o = this.gobbleToken(), !o) return o;
      if (r = this.gobbleBinaryOp(), !r) return o;
      for (n = {
        value: r,
        prec: e.binaryPrecedence(r),
        right_a: e.right_associative.has(r)
      }, h = this.gobbleToken(), h || this.throwError("Expected expression after " + r), s = [o, n, h]; r = this.gobbleBinaryOp();) {
        if (i = e.binaryPrecedence(r), 0 === i) {
          this.index -= r.length;
          break;
        }
        n = {
          value: r,
          prec: i,
          right_a: e.right_associative.has(r)
        }, l = r;
        var _a = function _a(_e7) {
          return n.right_a && _e7.right_a ? i > _e7.prec : i <= _e7.prec;
        };
        for (; s.length > 2 && _a(s[s.length - 2]);) h = s.pop(), r = s.pop().value, o = s.pop(), t = {
          type: e.BINARY_EXP,
          operator: r,
          left: o,
          right: h
        }, s.push(t);
        t = this.gobbleToken(), t || this.throwError("Expected expression after " + l), s.push(n, t);
      }
      for (a = s.length - 1, t = s[a]; a > 1;) t = {
        type: e.BINARY_EXP,
        operator: s[a - 1].value,
        left: s[a - 2],
        right: t
      }, a -= 2;
      return t;
    }
  }, {
    key: "gobbleToken",
    value: function gobbleToken() {
      var t, r, i, s;
      if (this.gobbleSpaces(), s = this.searchHook("gobble-token"), s) return this.runHook("after-token", s);
      if (t = this.code, e.isDecimalDigit(t) || t === e.PERIOD_CODE) return this.gobbleNumericLiteral();
      if (t === e.SQUOTE_CODE || t === e.DQUOTE_CODE) s = this.gobbleStringLiteral();else if (t === e.OBRACK_CODE) s = this.gobbleArray();else {
        for (r = this.expr.substr(this.index, e.max_unop_len), i = r.length; i > 0;) {
          if (e.unary_ops.hasOwnProperty(r) && (!e.isIdentifierStart(this.code) || this.index + r.length < this.expr.length && !e.isIdentifierPart(this.expr.charCodeAt(this.index + r.length)))) {
            this.index += i;
            var _t = this.gobbleToken();
            return _t || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
              type: e.UNARY_EXP,
              operator: r,
              argument: _t,
              prefix: !0
            });
          }
          r = r.substr(0, --i);
        }
        e.isIdentifierStart(t) ? (s = this.gobbleIdentifier(), e.literals.hasOwnProperty(s.name) ? s = {
          type: e.LITERAL,
          value: e.literals[s.name],
          raw: s.name
        } : s.name === e.this_str && (s = {
          type: e.THIS_EXP
        })) : t === e.OPAREN_CODE && (s = this.gobbleGroup());
      }
      return s ? (s = this.gobbleTokenProperty(s), this.runHook("after-token", s)) : this.runHook("after-token", !1);
    }
  }, {
    key: "gobbleTokenProperty",
    value: function gobbleTokenProperty(t) {
      this.gobbleSpaces();
      var r = this.code;
      for (; r === e.PERIOD_CODE || r === e.OBRACK_CODE || r === e.OPAREN_CODE || r === e.QUMARK_CODE;) {
        var _i2 = void 0;
        if (r === e.QUMARK_CODE) {
          if (this.expr.charCodeAt(this.index + 1) !== e.PERIOD_CODE) break;
          _i2 = !0, this.index += 2, this.gobbleSpaces(), r = this.code;
        }
        this.index++, r === e.OBRACK_CODE ? (t = {
          type: e.MEMBER_EXP,
          computed: !0,
          object: t,
          property: this.gobbleExpression()
        }, this.gobbleSpaces(), r = this.code, r !== e.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : r === e.OPAREN_CODE ? t = {
          type: e.CALL_EXP,
          arguments: this.gobbleArguments(e.CPAREN_CODE),
          callee: t
        } : (r === e.PERIOD_CODE || _i2) && (_i2 && this.index--, this.gobbleSpaces(), t = {
          type: e.MEMBER_EXP,
          computed: !1,
          object: t,
          property: this.gobbleIdentifier()
        }), _i2 && (t.optional = !0), this.gobbleSpaces(), r = this.code;
      }
      return t;
    }
  }, {
    key: "gobbleNumericLiteral",
    value: function gobbleNumericLiteral() {
      var t,
        r,
        i = "";
      for (; e.isDecimalDigit(this.code);) i += this.expr.charAt(this.index++);
      if (this.code === e.PERIOD_CODE) for (i += this.expr.charAt(this.index++); e.isDecimalDigit(this.code);) i += this.expr.charAt(this.index++);
      if (t = this["char"], "e" === t || "E" === t) {
        for (i += this.expr.charAt(this.index++), t = this["char"], "+" !== t && "-" !== t || (i += this.expr.charAt(this.index++)); e.isDecimalDigit(this.code);) i += this.expr.charAt(this.index++);
        e.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + i + this["char"] + ")");
      }
      return r = this.code, e.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + i + this["char"] + ")") : (r === e.PERIOD_CODE || 1 === i.length && i.charCodeAt(0) === e.PERIOD_CODE) && this.throwError("Unexpected period"), {
        type: e.LITERAL,
        value: parseFloat(i),
        raw: i
      };
    }
  }, {
    key: "gobbleStringLiteral",
    value: function gobbleStringLiteral() {
      var t = "";
      var r = this.index,
        i = this.expr.charAt(this.index++);
      var s = !1;
      for (; this.index < this.expr.length;) {
        var _e8 = this.expr.charAt(this.index++);
        if (_e8 === i) {
          s = !0;
          break;
        }
        if ("\\" === _e8) switch (_e8 = this.expr.charAt(this.index++), _e8) {
          case "n":
            t += "\n";
            break;
          case "r":
            t += "\r";
            break;
          case "t":
            t += "\t";
            break;
          case "b":
            t += "\b";
            break;
          case "f":
            t += "\f";
            break;
          case "v":
            t += "\v";
            break;
          default:
            t += _e8;
        } else t += _e8;
      }
      return s || this.throwError('Unclosed quote after "' + t + '"'), {
        type: e.LITERAL,
        value: t,
        raw: this.expr.substring(r, this.index)
      };
    }
  }, {
    key: "gobbleIdentifier",
    value: function gobbleIdentifier() {
      var t = this.code,
        r = this.index;
      for (e.isIdentifierStart(t) ? this.index++ : this.throwError("Unexpected " + this["char"]); this.index < this.expr.length && (t = this.code, e.isIdentifierPart(t));) this.index++;
      return {
        type: e.IDENTIFIER,
        name: this.expr.slice(r, this.index)
      };
    }
  }, {
    key: "gobbleArguments",
    value: function gobbleArguments(t) {
      var r = [];
      var i = !1,
        s = 0;
      for (; this.index < this.expr.length;) {
        this.gobbleSpaces();
        var n = this.code;
        if (n === t) {
          i = !0, this.index++, t === e.CPAREN_CODE && s && s >= r.length && this.throwError("Unexpected token " + String.fromCharCode(t));
          break;
        }
        if (n === e.COMMA_CODE) {
          if (this.index++, s++, s !== r.length) if (t === e.CPAREN_CODE) this.throwError("Unexpected token ,");else if (t === e.CBRACK_CODE) for (var _e10 = r.length; _e10 < s; _e10++) r.push(null);
        } else if (r.length !== s && 0 !== s) this.throwError("Expected comma");else {
          var _t2 = this.gobbleExpression();
          _t2 && _t2.type !== e.COMPOUND || this.throwError("Expected comma"), r.push(_t2);
        }
      }
      return i || this.throwError("Expected " + String.fromCharCode(t)), r;
    }
  }, {
    key: "gobbleGroup",
    value: function gobbleGroup() {
      this.index++;
      var t = this.gobbleExpressions(e.CPAREN_CODE);
      if (this.code === e.CPAREN_CODE) return this.index++, 1 === t.length ? t[0] : !!t.length && {
        type: e.SEQUENCE_EXP,
        expressions: t
      };
      this.throwError("Unclosed (");
    }
  }, {
    key: "gobbleArray",
    value: function gobbleArray() {
      return this.index++, {
        type: e.ARRAY_EXP,
        elements: this.gobbleArguments(e.CBRACK_CODE)
      };
    }
  }], [{
    key: "version",
    get: function get() {
      return "1.3.8";
    }
  }, {
    key: "toString",
    value: function toString() {
      return "JavaScript Expression Parser (JSEP) v" + e.version;
    }
  }, {
    key: "addUnaryOp",
    value: function addUnaryOp(t) {
      return e.max_unop_len = Math.max(t.length, e.max_unop_len), e.unary_ops[t] = 1, e;
    }
  }, {
    key: "addBinaryOp",
    value: function addBinaryOp(t, r, i) {
      return e.max_binop_len = Math.max(t.length, e.max_binop_len), e.binary_ops[t] = r, i ? e.right_associative.add(t) : e.right_associative["delete"](t), e;
    }
  }, {
    key: "addIdentifierChar",
    value: function addIdentifierChar(t) {
      return e.additional_identifier_chars.add(t), e;
    }
  }, {
    key: "addLiteral",
    value: function addLiteral(t, r) {
      return e.literals[t] = r, e;
    }
  }, {
    key: "removeUnaryOp",
    value: function removeUnaryOp(t) {
      return delete e.unary_ops[t], t.length === e.max_unop_len && (e.max_unop_len = e.getMaxKeyLen(e.unary_ops)), e;
    }
  }, {
    key: "removeAllUnaryOps",
    value: function removeAllUnaryOps() {
      return e.unary_ops = {}, e.max_unop_len = 0, e;
    }
  }, {
    key: "removeIdentifierChar",
    value: function removeIdentifierChar(t) {
      return e.additional_identifier_chars["delete"](t), e;
    }
  }, {
    key: "removeBinaryOp",
    value: function removeBinaryOp(t) {
      return delete e.binary_ops[t], t.length === e.max_binop_len && (e.max_binop_len = e.getMaxKeyLen(e.binary_ops)), e.right_associative["delete"](t), e;
    }
  }, {
    key: "removeAllBinaryOps",
    value: function removeAllBinaryOps() {
      return e.binary_ops = {}, e.max_binop_len = 0, e;
    }
  }, {
    key: "removeLiteral",
    value: function removeLiteral(t) {
      return delete e.literals[t], e;
    }
  }, {
    key: "removeAllLiterals",
    value: function removeAllLiterals() {
      return e.literals = {}, e;
    }
  }, {
    key: "parse",
    value: function parse(t) {
      return new e(t).parse();
    }
  }, {
    key: "getMaxKeyLen",
    value: function getMaxKeyLen(_e2) {
      return Math.max.apply(Math, [0].concat(_toConsumableArray(Object.keys(_e2).map(function (_e3) {
        return _e3.length;
      }))));
    }
  }, {
    key: "isDecimalDigit",
    value: function isDecimalDigit(_e4) {
      return _e4 >= 48 && _e4 <= 57;
    }
  }, {
    key: "binaryPrecedence",
    value: function binaryPrecedence(t) {
      return e.binary_ops[t] || 0;
    }
  }, {
    key: "isIdentifierStart",
    value: function isIdentifierStart(t) {
      return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 128 && !e.binary_ops[String.fromCharCode(t)] || e.additional_identifier_chars.has(String.fromCharCode(t));
    }
  }, {
    key: "isIdentifierPart",
    value: function isIdentifierPart(t) {
      return e.isIdentifierStart(t) || e.isDecimalDigit(t);
    }
  }]);
  return e;
}();
var t = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  _createClass(_class, [{
    key: "add",
    value: function add(e, t, r) {
      if ("string" != typeof arguments[0]) for (var _e11 in arguments[0]) this.add(_e11, arguments[0][_e11], arguments[1]);else (Array.isArray(e) ? e : [e]).forEach(function (e) {
        this[e] = this[e] || [], t && this[e][r ? "unshift" : "push"](t);
      }, this);
    }
  }, {
    key: "run",
    value: function run(e, t) {
      this[e] = this[e] || [], this[e].forEach(function (e) {
        e.call(t && t.context ? t.context : t, t);
      });
    }
  }]);
  return _class;
}())();
Object.assign(e, {
  hooks: t,
  plugins: new ( /*#__PURE__*/function () {
    function _class2(e) {
      _classCallCheck(this, _class2);
      this.jsep = e, this.registered = {};
    }
    _createClass(_class2, [{
      key: "register",
      value: function register() {
        var _this = this;
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        e.forEach(function (e) {
          if ("object" != _typeof(e) || !e.name || !e.init) throw new Error("Invalid JSEP plugin format");
          _this.registered[e.name] || (e.init(_this.jsep), _this.registered[e.name] = e);
        });
      }
    }]);
    return _class2;
  }())(e),
  COMPOUND: "Compound",
  SEQUENCE_EXP: "SequenceExpression",
  IDENTIFIER: "Identifier",
  MEMBER_EXP: "MemberExpression",
  LITERAL: "Literal",
  THIS_EXP: "ThisExpression",
  CALL_EXP: "CallExpression",
  UNARY_EXP: "UnaryExpression",
  BINARY_EXP: "BinaryExpression",
  ARRAY_EXP: "ArrayExpression",
  TAB_CODE: 9,
  LF_CODE: 10,
  CR_CODE: 13,
  SPACE_CODE: 32,
  PERIOD_CODE: 46,
  COMMA_CODE: 44,
  SQUOTE_CODE: 39,
  DQUOTE_CODE: 34,
  OPAREN_CODE: 40,
  CPAREN_CODE: 41,
  OBRACK_CODE: 91,
  CBRACK_CODE: 93,
  QUMARK_CODE: 63,
  SEMCOL_CODE: 59,
  COLON_CODE: 58,
  unary_ops: {
    "-": 1,
    "!": 1,
    "~": 1,
    "+": 1
  },
  binary_ops: {
    "||": 1,
    "&&": 2,
    "|": 3,
    "^": 4,
    "&": 5,
    "==": 6,
    "!=": 6,
    "===": 6,
    "!==": 6,
    "<": 7,
    ">": 7,
    "<=": 7,
    ">=": 7,
    "<<": 8,
    ">>": 8,
    ">>>": 8,
    "+": 9,
    "-": 9,
    "*": 10,
    "/": 10,
    "%": 10
  },
  right_associative: new Set(),
  additional_identifier_chars: new Set(["$", "_"]),
  literals: {
    "true": !0,
    "false": !1,
    "null": null
  },
  this_str: "this"
}), e.max_unop_len = e.getMaxKeyLen(e.unary_ops), e.max_binop_len = e.getMaxKeyLen(e.binary_ops);
var r = function r(t) {
  return new e(t).parse();
};
Object.getOwnPropertyNames(e).forEach(function (t) {
  void 0 === r[t] && "prototype" !== t && (r[t] = e[t]);
}), r.Jsep = e;
var i = {
  name: "ternary",
  init: function init(e) {
    e.hooks.add("after-expression", function (t) {
      if (t.node && this.code === e.QUMARK_CODE) {
        this.index++;
        var _r2 = t.node,
          _i3 = this.gobbleExpression();
        if (_i3 || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === e.COLON_CODE) {
          this.index++;
          var _s = this.gobbleExpression();
          if (_s || this.throwError("Expected expression"), t.node = {
            type: "ConditionalExpression",
            test: _r2,
            consequent: _i3,
            alternate: _s
          }, _r2.operator && e.binary_ops[_r2.operator] <= .9) {
            var _i4 = _r2;
            for (; _i4.right.operator && e.binary_ops[_i4.right.operator] <= .9;) _i4 = _i4.right;
            t.node.test = _i4.right, _i4.right = t.node, t.node = _r2;
          }
        } else this.throwError("Expected :");
      }
    });
  }
};
r.plugins.register(i);
window.jsep = e;

(function(){
    var OCURLY_CODE = 123; // {
    var CCURLY_CODE = 125; // }
    var OBJECT_EXP  = 'ObjectExpression';
    var PROPERTY    = 'Property';

    window.jsep.plugins.register({
        name: 'object',
    
        init: function(jsep) {
            // Object literal support
            function gobbleObjectExpression(env) {
                if (this.code === OCURLY_CODE) {
                    this.index++;
                    var properties = [];
    
                    while (!isNaN(this.code)) {
                        this.gobbleSpaces();
                        if (this.code === CCURLY_CODE) {
                            this.index++;
                            env.node = this.gobbleTokenProperty({
                                type: OBJECT_EXP,
                                properties: properties,
                            });
                            return;
                        }
    
                        // Note: using gobbleExpression instead of gobbleToken to support object destructuring
                        var key = this.gobbleExpression();
                        if (!key) {
                            break; // missing }
                        }
    
                        this.gobbleSpaces();
                        if (key.type === jsep.IDENTIFIER && (this.code === jsep.COMMA_CODE || this.code === CCURLY_CODE)) {
                            // property value shorthand
                            properties.push({
                                type: PROPERTY,
                                computed: false,
                                key: key,
                                value: key,
                                shorthand: true,
                            });
                        }
                        else if (this.code === jsep.COLON_CODE) {
                            this.index++;
                            var value = this.gobbleExpression();
    
                            if (!value) {
                                this.throwError('unexpected object property');
                            }
                            var computed = key.type === jsep.ARRAY_EXP;
                            properties.push({
                                type: PROPERTY,
                                computed: computed,
                                key: computed
                                    ? key.elements[0]
                                    : key,
                                value: value,
                                shorthand: false,
                            });
                            this.gobbleSpaces();
                        }
                        else if (key) {
                            // spread, assignment (object destructuring with defaults), etc.
                            properties.push(key);
                        }
    
                        if (this.code === jsep.COMMA_CODE) {
                            this.index++;
                        }
                    }
                    this.throwError('missing }');
                }
            }
    
            jsep.hooks.add('gobble-token', gobbleObjectExpression);
        }
    });

    window.jsep.plugins.register({
        name: "new",
        init: function(jsep) {
          jsep.addUnaryOp('new');
      
          jsep.hooks.add('after-token', function gobbleNew(env) {
            var node = env.node;
            if (node && node.operator === 'new') {
              if (!node.argument || ![jsep.CALL_EXP, jsep.MEMBER_EXP].includes(node.argument.type)) {
                this.throwError('Expected new function()');
              }
              env.node = node.argument;
      
              // Change CALL_EXP to NewExpression (could be a nested member, even within a call expr)
              var callNode = env.node;
              // while (callNode.type === jsep.MEMBER_EXP || (
              //   callNode.type === jsep.CALL_EXP && callNode.callee.type === jsep.MEMBER_EXP)) {
              //   callNode = callNode.type === jsep.MEMBER_EXP
              //     ? callNode.object
              //     : callNode.callee.object;
              // }
              callNode.type = 'NewExpression';
            }
          });
        }
    })
})();